const regex = /880|8 X 3|2-inch|PU leather|96%|Pin Mechanism/gi;

const headings01 = document.querySelectorAll(".banner__header_text_h2");
const headings02 = document.querySelectorAll(".scene_graph_box_h2");

headings01.forEach((heading) => {
  heading.innerHTML = heading.innerHTML.replace(regex, (match) => {
    return `<span class="red-text">${match}</span>`;
  });
});

headings02.forEach((heading) => {
  heading.innerHTML = heading.innerHTML.replace(regex, (match) => {
    return `<span class="red-text">${match}</span>`;
  });
});
